import { Injectable } from "@angular/core";
import { ObgConfigFeAdaptiveClientCore } from "@obg/core.config";
import { ConfigService } from "@obg/ngx.global";

@Injectable({
	providedIn: "root",
})
export class GoogleAuthTransactionConfigService {
	constructor(private service: ConfigService<ObgConfigFeAdaptiveClientCore>) {}

	getOpenIdConnectUrlEndpoint(): string {
		return this.service.get((x) => x.core.googleAuthTransaction.endpoints?.openIdConnect, "v1/oidc-uris");
	}
}
